module.exports = __webpack_public_path__ + "img/93960.41e3c316.svg";